import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ShowLayout from "layouts/ShowLayout";
import get from "lodash/get";
import titleCase from 'title-case'

const styles = () => ({
  root: {
    flexGrow: 1,
  },
  label: {
    color: "gray",
  },
});

class NotificationsShow extends React.PureComponent {
  render() {
    const { classes, notification } = this.props;

    if (!notification) return <div>Loading...</div>;

    const customers = get(notification, "customerNames");

    const customerNames = Array.isArray(customers)
      ? customers.map(name => <span>{name}, </span>)
      : customers;

    return (
      <div className={classes.root}>
        <ShowLayout moduleName={"notifications"} actions={{ edit: false }}>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={8}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Customer:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {/* {get(notification, "customerId.name")} */}
                {customerNames}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Region:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {get(notification, "regionId.name")}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Equipment:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {get(notification, "equipmentId.name")}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Agreement:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {get(notification, "agreementId.name")}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Message Status:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {titleCase(get(notification, "status"))}
              </Typography>
            </Grid>


            <Grid item xs={12} sm={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Message:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {notification.message}
              </Typography>
            </Grid>
          </Grid>
        </ShowLayout>
      </div>
    );
  }
}

NotificationsShow.defaultProps = {
  isEditing: false,
};

export default withStyles(styles)(NotificationsShow);
